import React from 'react';
import { StarFilter, SortAndFilterBar, PriceFilter, AmenitiesFilter } from '../../src/components/stays/SortAndFilters';
import { SortWithProps } from '../../src/components/stays/SortAndFilters/Sort';

import FlowProvider from '../../src/context/FlowContext';
import ShoppingProvider, { TChartData, TFilters, TPriceRange, TPriceStats } from '../../src/context/ShoppingContext';
import StayLocationFactory from '../../pactum-server/stubs/StayLocationFactory';
import { SearchFormBanner } from '../../src/components/public/ResultsPage/ResultsPage.styles';
import Bootstrap from '../bootstrap';
import { Divider } from '@fctg-ds/core';
import { Flex } from '../../src/components/common/Flex';

const Filters: React.FC = () => {
  const content = { destination: StayLocationFactory(), destinationContent: false };
  const selectedStay = '4005620';
  const filters: TFilters = {
    stars: [false, false, false, false, false],
    price: { min: 0, max: 100 },
    amenities: [],
  };
  const getResultCount = (selected: boolean[]) => selected.length * 100;
  const setStars = (selected: boolean[]) => console.log(selected);

  const getPriceResultsCount = (range: TPriceRange): number => 55;
  const updateRange = (range: TPriceRange) => {
    filters.price = range;
  };
  const getMockChartData = (): TChartData => {
    const data: TChartData = [];
    for (let i = 0; i < 20; i++) {
      data.push({
        label: i,
        count: Math.floor(Math.random() * 100),
      });
    }
    return data;
  };

  const getMockPriceStats = (mockChartData: TChartData): TPriceStats => {
    let lowest = mockChartData[0].label;
    let highest = mockChartData[0].label;
    let average = 0;

    mockChartData.forEach((stats) => {
      if (stats.label < lowest) lowest = stats.label;
      if (stats.label > highest) highest = stats.label;
      average += stats.label;
    });

    average /= mockChartData.length;

    return {
      lowest,
      highest,
      average,
    };
  };

  const mockChartData = getMockChartData();
  const mockPriceStats = getMockPriceStats(mockChartData);

  const setAmenities = (amenities: string[]) => console.log(amenities);
  const getMockAmenities = () => [
    '24 Hour Front Desk',
    'Air conditioning',
    'Bar/Lounge',
    'Casino',
    'Concierge',
    'Cribs Available',
    'Fitness Center',
    'Free car parking',
    'Free Wifi',
    'Jacuzzi',
    'Kitchen',
    'Laundry Service',
    'Luggage storage',
    'Non smoking rooms - remove for AU ??',
    'Parking',
    'Pets allowed',
    'Restaurant(s)',
    'Sauna',
    'Shuttle service - is this airport shuttle?',
    'Smoking area',
    'Spa',
    'Swimming pool',
    'TV',
    'Valet parking',
    'Washing Machine',
    'Wifi',
  ];

  return (
    <Bootstrap>
      <FlowProvider dsContent={content} productId={selectedStay}>
        <ShoppingProvider>
          <SearchFormBanner>
            <SortAndFilterBar>
              <SortWithProps />
              <StarFilter
                defaultLabel={'Stars'}
                filters={filters}
                getResultCount={getResultCount}
                setStars={setStars}
              />
              <PriceFilter
                hasAvailability={true}
                defaultLabel="Price"
                filters={filters}
                getResultCount={getPriceResultsCount}
                updateRange={updateRange}
                getPriceStats={() => mockPriceStats}
                getChartData={() => mockChartData}
              />
              <Flex style={{ alignItems: 'center', justifyContent: 'center', flexGrow: 0 }}>
                <Divider style={{ margin: '10px' }} variant="dot" />
              </Flex>
              <AmenitiesFilter hasContent={true} getWeightedAmenities={getMockAmenities} setAmenities={setAmenities} />
            </SortAndFilterBar>
          </SearchFormBanner>
        </ShoppingProvider>
      </FlowProvider>
    </Bootstrap>
  );
};

export default Filters;
